import { render, staticRenderFns } from "./CartDetails.vue?vue&type=template&id=20249c4f&scoped=true&"
import script from "./CartDetails.vue?vue&type=script&lang=js&"
export * from "./CartDetails.vue?vue&type=script&lang=js&"
import style0 from "./CartDetails.vue?vue&type=style&index=0&id=20249c4f&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20249c4f",
  null
  
)

export default component.exports